<template>
  <p
    :class="$style.copyright"
    v-show="!debugInfoVisibility"
    @click="toggleDebugInfoVisiblity"
  >
    &copy; {{ year }} 400F, Inc.
  </p>
  <p
    :class="[$style.footer__debug, $style.debug]"
    v-show="debugInfoVisibility"
    @click="toggleDebugInfoVisiblity"
  >
    [DEBUG]
    <span
      :class="[$style.debug__data, $style.data]"
      v-for="{ key, value } in debugInfo"
      :key="key"
      >{{ key }}: {{ value }}</span
    >
    <button
      :class="[$style.debug__action, $style.switch]"
      @click.stop="toggleAlpha"
    >
      dolphin jump!
    </button>
  </p>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { VERSION } from '@/config'
import { useTestMode } from '@/hooks/useTestMode'

//
// TODO: このコンポーネントはあとで内容を変える
//

const debugInfoVisibility = ref(false)
const toggleDebugInfoVisiblity = () => {
  debugInfoVisibility.value = !debugInfoVisibility.value
}

const { enabled, toggleAlpha } = useTestMode()
const debugInfo = computed(() => [
  { key: 'version', value: VERSION },
  { key: 'enabledStage', value: JSON.stringify(enabled.value) },
])

const year = new Date().getFullYear()
</script>

<style lang="scss" module>
.copyright {
  display: flex;
  align-items: center;
  color: $color-label-white;
  font-size: 10px;
}

.debug {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 4px 8px;
  background-color: $color-surface-primary;
  color: $color-text-and-object-low-emphasis;
  font-size: 8px;

  &__data {
    margin: 0 2px;
    word-break: break-all;
  }

  &__action {
    margin: 0 12px;
  }
}

.data {
  padding: 2px 4px;
  border-radius: 4px;
  color: $color-text-and-object-medium-emphasis;
  font-size: 8px;
}

.switch {
  padding: 2px 4px;
  border: 1px solid $color-border-accent-primary;
  background-color: $color-surface-primary;
  border-radius: 4px;
  color: $color-text-and-object-accent-primary;
  font-size: 8px;
}
</style>
